"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startRecorderLoop = void 0;
const provider_user_1 = require("@framework/provider-user");
const utils_1 = require("./utils");
const sleep = (ms, signal) => new Promise((resolve, reject) => {
    if (signal.aborted) {
        reject(new DOMException("Aborted", "AbortError"));
        return;
    }
    const timer = { id: 0 };
    const onAbort = () => {
        clearTimeout(timer.id);
        reject(new DOMException("Aborted", "AbortError"));
    };
    timer.id = setTimeout(() => {
        signal.removeEventListener("abort", onAbort);
        resolve();
    }, ms);
    signal.addEventListener("abort", onAbort);
});
const startRecorderLoop = (settings, callbacks, lastTickTimeRef) => {
    if (!(settings === null || settings === void 0 ? void 0 : settings.upd) || settings.upd <= 0) {
        return () => { };
    }
    const controller = new AbortController();
    const { signal } = controller;
    const intervalMs = settings.upd * 1000;
    let tickId = 0;
    const loop = async () => {
        let lastTickTime = (lastTickTimeRef === null || lastTickTimeRef === void 0 ? void 0 : lastTickTimeRef.current) && Number.isFinite(new Date(lastTickTimeRef.current).getTime())
            ? new Date(lastTickTimeRef.current)
            : null;
        try {
            while (!signal.aborted) {
                const now = (0, utils_1.toFakeUtc)(new Date(), settings.dbTz);
                const windowStart = (0, utils_1.calculateStartDate)(now, provider_user_1.SelfRecorderRangeEnum[settings.range], settings.value);
                const overlapMs = intervalMs;
                let deltaStart = lastTickTime
                    ? new Date(Math.max(windowStart.getTime(), lastTickTime.getTime() - overlapMs))
                    : windowStart;
                if (deltaStart.getTime() >= now.getTime()) {
                    deltaStart = new Date(now.getTime() - 1);
                }
                if (signal.aborted)
                    break;
                callbacks.onTick({
                    tickId: ++tickId,
                    windowStart: windowStart.toISOString(),
                    windowEnd: now.toISOString(),
                    deltaStart: deltaStart.toISOString(),
                    deltaEnd: now.toISOString(),
                });
                lastTickTime = now;
                if (lastTickTimeRef) {
                    lastTickTimeRef.current = now.toISOString();
                }
                await sleep(intervalMs, signal);
            }
        }
        catch (e) {
            if (e.name !== "AbortError") {
                console.error(e);
            }
        }
    };
    void loop();
    return () => {
        controller.abort();
    };
};
exports.startRecorderLoop = startRecorderLoop;
//# sourceMappingURL=recorder-loop.js.map